import * as swcHelpers from '@swc/helpers';
import { Locales } from '@grandvisionhq/state';
import * as utils from '@grandvisionhq/utils';
import { createAltTag } from '../utils/create-alt-tag.js';
import { createProductTypeName } from '../utils/create-product-type-name.js';
import { getDiscount } from '../utils/get-discount.js';
import { getSearchLocalizedValue, getSearchJoinedLocalizedValues } from '../utils/get-search-localized-value.js';

const english = Locales['en-GB'];
//TODO: final check when all the properties are added by the backend to the new index. Story: CXCD-9919
const mapListingProductRecordToListingProduct = (product, intl)=>{
    var ref;
    const { getLabel , locale  } = intl;
    const labels = {
        lens: getLabel(`products.unit.contactLens`),
        lenses: getLabel(`products.unit.contactLenses`),
        perBox: getLabel(`products.perBox`)
    };
    const slug = product.slug;
    const masterVariant = mapVariant(product, locale, labels);
    const productType = createProductTypeName(product.productType);
    if (!slug || !product.objectID || !productType || !masterVariant) {
        console.error('No slug, objectId, productType or masterVariant found for product sku: ', product.sku);
        return undefined;
    }
    var ref1;
    const variants = (ref1 = (ref = product.variants) === null || ref === void 0 ? void 0 : ref.map((variant)=>mapVariant(product, locale, labels, variant)
    ).filter(utils.isDefined)) !== null && ref1 !== void 0 ? ref1 : [];
    const firstCategory = product.categories[0];
    const category = firstCategory ? getSearchLocalizedValue(firstCategory, 'category_name', english) : undefined;
    var ref2, ref3;
    return {
        category,
        includedVatAmount: product.includedVatAmount,
        isOnStock: product.isOnStock,
        masterVariant,
        name: {
            en: (ref2 = getSearchLocalizedValue(product, 'name', english)) !== null && ref2 !== void 0 ? ref2 : '',
            localized: (ref3 = getSearchLocalizedValue(product, 'name', locale)) !== null && ref3 !== void 0 ? ref3 : ''
        },
        objectID: product.objectID,
        offering: undefined,
        productType,
        ratingsSummary: undefined,
        slug,
        variants
    };
};
const mapVariant = (product, locale, labels, variant)=>{
    var ref, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    const altTag = createAltTag(product, locale, labels);
    if (variant && !variant.priceAmount && !variant.priceCurrency && !variant.brandModel && !((ref = variant.images) === null || ref === void 0 ? void 0 : ref.length) && !variant.sku) {
        console.error('Variant found with insufficiant info for product: ', product.sku);
        return undefined;
    }
    if (!product.priceAmount || !product.priceCurrency || !product.brand || !product.brandModel || !product.brandModelColorCode || !((ref4 = product.images) === null || ref4 === void 0 ? void 0 : ref4.length) || // !product.erpId ||
    !product.sku) {
        return undefined;
    }
    const frame = {
        color: {
            en: getSearchJoinedLocalizedValues(product, 'frameColor', english),
            localized: getSearchJoinedLocalizedValues(product, 'frameColor', locale)
        },
        material: {
            en: getSearchLocalizedValue(product, 'frameMaterial', english)
        },
        shape: {
            en: getSearchLocalizedValue(product, 'frameShape', english)
        },
        type: {
            en: getSearchLocalizedValue(product, 'frameType', english)
        }
    };
    const discount = product.discountedPrice ? {
        description: getSearchLocalizedValue(product, 'discountDescription', locale),
        price: product.discountedPrice,
        badge: getDiscount(locale, product.discountedPriceCurrencyCode, product.discountType, product.discountedPrice),
        validFrom: product.discountValidFrom,
        validUntil: product.discountValidUntil
    } : undefined;
    const images = variant ? variant.images.map((img)=>swcHelpers.objectSpread({}, img, {
            altTag
        })
    ) : product.images.map((img)=>swcHelpers.objectSpread({}, img, {
            altTag
        })
    );
    const tagKey = variant ? (ref5 = variant.tags) === null || ref5 === void 0 ? void 0 : (ref6 = ref5[0]) === null || ref6 === void 0 ? void 0 : ref6.key : (ref7 = product.tags) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : ref8.key;
    const tagValue = variant ? (ref9 = variant.tags) === null || ref9 === void 0 ? void 0 : (ref10 = ref9[0]) === null || ref10 === void 0 ? void 0 : ref10.value : (ref11 = product.tags) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : ref12.value;
    var ref13, _name_en;
    return {
        brand: {
            name: product.brand,
            model: variant ? variant.brandModel : product.brandModel,
            modelCode: variant ? variant.brandModelCode : product.brandModelCode
        },
        erpId: 'product.erpId',
        description: (ref13 = getSearchLocalizedValue(product, 'description', locale)) !== null && ref13 !== void 0 ? ref13 : '',
        frame,
        faceShape: {
            en: getSearchJoinedLocalizedValues(product, 'faceShape', english)
        },
        gender: {
            en: getSearchJoinedLocalizedValues(product, 'targetGender', english)
        },
        lensColor: getSearchLocalizedValue(product, 'lensColor', locale),
        lensType: {
            en: getSearchLocalizedValue(product, 'lensType', english)
        },
        replacementFrequency: getSearchLocalizedValue(product, 'replacementFrequency', locale),
        material: getSearchLocalizedValue(product, 'material', locale),
        accessoryType: {
            en: getSearchLocalizedValue(product, 'accessoryType', english),
            localized: getSearchLocalizedValue(product, 'accessoryType', locale)
        },
        accessoryColor: {
            en: getSearchJoinedLocalizedValues(product, 'accessoryColor', english),
            localized: getSearchJoinedLocalizedValues(product, 'accessoryColor', locale)
        },
        contactLensCareType: getSearchLocalizedValue(product, 'contactLensCareType', locale),
        isInsuranceReimbursable: Boolean(product.isInsuranceReimbursable),
        power: product.power,
        priceIncludedAmount: product.priceIncludedAmount,
        packageOption: product.packageOption,
        packageQuantity: product.packageQuantity,
        solutionType: product.solutionType,
        isExclusiveBrand: product.isExclusiveBrand,
        name: (_name_en = product.name_en) !== null && _name_en !== void 0 ? _name_en : '',
        sku: variant ? variant.sku : product.sku,
        tag: {
            key: tagKey,
            value: tagValue
        },
        images,
        pricing: {
            bestPrice: product.bestPrice,
            price: {
                isCentAmount: false,
                originalPrice: variant ? variant.priceAmount : product.priceAmount,
                currencyCode: variant ? variant.priceCurrency : product.priceCurrency,
                discount
            },
            pricePerUnit: {
                amount: product.pricePerUnitAmount,
                currencyCode: product.pricePerUnitCurrency
            }
        }
    };
};

export { mapListingProductRecordToListingProduct, mapVariant };
//# sourceMappingURL=map-listing-product-record-to-listing-product.js.map
